const getResponseFields = (data) => {
    const titles = [
      "FullName", "Email", "Address", "Phone", "DatePicker",
      "Appointment", "ShortText", "LongText", "DropDown",
      "SingleChoice", "MultiChoice", "Number", "FileUpload",
      "Time", "Spinner", "Table", "StarRating", "ScaleRating",
      "ProductList", "Image", "FillInTheBlank", "Paragraph"
    ];
  
    return titles.reduce((acc, title) => {
      const field = data?.find((item) => item.title === title);
      acc[title] = field || null;
      acc[`show${title}`] = !!field;
      return acc;
    }, {});
  };
  
  export default getResponseFields;
  